import { useEffect } from 'react'
import { useAppDispatch } from '@hooks/reduxHooks'
import { generatorElutionService } from '@services/generatorElutionService'
import { getGeneratorElutions } from '@state/reducers/generatorElutionReducer'

export function useGeneratorElutionSSE() {
  const dispatch = useAppDispatch()

  useEffect(() => {
    const unsubscribe = generatorElutionService.subscribeToEvents(() => {
      dispatch(getGeneratorElutions())
    })
    return unsubscribe
  }, [dispatch])
}
